export default __webpack_public_path__ + "static/media/testimonial-02.e8a05fb5.jpg";